import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Subscription } from '../subscription/subscription.model';

export interface BulkState extends EntityState<Subscription>, ActiveState {
  orgUuidPreventBulk: string[];
}

export function createInitialState(): BulkState {
  return <BulkState>{
    orgUuidPreventBulk: []
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'bulk_subscription', idKey: 'uuid' })
export class BulkStore extends EntityStore<BulkState, Subscription> {
  constructor() {
    super(createInitialState());
  }

  addOrgUuidPreventBulk(orgUuid: string) {
    this.update(state => ({ orgUuidPreventBulk: [...state.orgUuidPreventBulk, orgUuid] }));
  }
}
